import { render, staticRenderFns } from "./CertifyBox.vue?vue&type=template&id=221929ff&scoped=true"
import script from "./CertifyBox.vue?vue&type=script&lang=js"
export * from "./CertifyBox.vue?vue&type=script&lang=js"
import style0 from "./CertifyBox.vue?vue&type=style&index=0&id=221929ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221929ff",
  null
  
)

export default component.exports